module.exports = __webpack_public_path__ + "../static/img/alchemy_mini.2c819382.png";